
import React from 'react';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';

interface ExamFormActionsProps {
  isSubmitting: boolean;
  isEditMode: boolean;
  onCancel: () => void;
}

const ExamFormActions = ({ 
  isSubmitting, 
  isEditMode, 
  onCancel 
}: ExamFormActionsProps) => {
  return (
    <div className="flex justify-end gap-3 pt-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isSubmitting}
        className="gap-2"
      >
        <Save className="h-4 w-4" />
        {isSubmitting ? 'Saving...' : (isEditMode ? 'Save Changes' : 'Add Result')}
      </Button>
    </div>
  );
};

export default ExamFormActions;
